
export default {
    authData: null,
    loggedIn: false,
    userData: [],
};
